import { business } from "database/schema";
import { createUpdateSchema } from "drizzle-zod";
import { z } from "zod";

export const createBusinessSchema = z.object({
  websiteUrl: z.string(),
  businessName: z.string().max(100),
  businessDescription: z.string().max(2000),
  blogUrl: z.string().nullable(),
  blogPostTitles: z.array(z.string()),
  industry: z.string(),
  products: z.array(z.string()),
  targetAudience: z.string().max(300),
  tone: z.string().max(300),
  keyFeatures: z.array(z.string()),
  pricing: z.string().max(1000),
});

export type CreateBusinessSchema = z.infer<typeof createBusinessSchema>;

export const createBusinessRequestInputSchema = z.object({
  url: z.url(),
});

export const updateBusinessSchema = createUpdateSchema(business, {
  id: z.any(),
});

export type UpdateBusinessSchema = z.infer<typeof updateBusinessSchema>;
